import script from "./BrandCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandCard.vue?vue&type=script&setup=true&lang=ts"

import "./BrandCard.vue?vue&type=style&index=0&id=36522c0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36522c0a"]])

export default __exports__